import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/teacher/resourceBook"

const resourceBook = {
  resourceBookListPage(pageSize, limit, versionId, keyWord) {
    return axios.get(pre + `/resourceBookListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          versionId: versionId,
          keyWord: keyWord
        }
    });
  },
  resourceBookInfo(id) {
    return axios.get(pre + `/resourceBookInfo`, {params: {id: id}});
  },
  resourceBookSave(params) {
    return axios.post(pre + `/resourceBookSave`, qs.stringify(params));
  },
  resourceBookDelete(id) {
    return axios.delete(pre + `/resourceBookDelete`, {params: {id: id}});
  },
}
export default resourceBook;



// WEBPACK FOOTER //
// ./src/api/teacher/resourceBook.js